<template>
  <div class="panel-body">
    <div class="left">
      <div class="mr-t-10">
        <fieldset class="border">
          <legend class="border">通知設定</legend>
          <div class="noti-setting-discription">
            売上通知について設定ができます。<br>
            ※メールマガジン等の売上通知以外のメールについては、各メールに記載のリンクより変更をお願いします。
          </div>
          <form data-vv-scope="setting-form">
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-3">メールアドレス
                <span class="text-danger m-r-sm">＊</span>
              </label>
              <div class="flex-item flex-input">
                <span style="display: block" v-show="errors.has('setting-form.noticeEmail')" class="text-danger">
                  ※{{ errors.first('setting-form.noticeEmail') }}
                </span>
                <input
                  class="form-control"
                  type="text"
                  v-model="userInfo.noticeEmail"
                  v-validate="'required|email'"
                  data-vv-as="メールアドレス"
                  data-vv-name="noticeEmail"
                  data-vv-scope="setting-form"
                >
              </div>
            </div>
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-3">売上通知</label>
              <div class="flex-item">
                <toggle-button
                  v-model="isNoticeEmail"
                  :labels="{checked: 'ON', unchecked: 'OFF'}"
                  :height=30
                  :width=62
                  :sync="true"
                />
              </div>
            </div>
            <div class="update-btn">
              <button class="btn btn-warning w-120" @click.prevent="updateSetting()" :disabled="disabled">更新</button>
            </div>
          </form>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import Const from '@/common/msg'
import SettingService from '@/services/settingservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      userInfo: {
        noticeEmail: null,
        isNoticeEmail: null
      },
      defaultUserInfo: null,
      disabled: true,
      err: null,
      loader: null
    }
  },
  created () {
    this.getUserInfo()
  },
  mounted () {
    this.checkDisabledButton()
    if (this.currentTab && this.currentTab === 'others') {
      let logParams = {
        name: eventCode.settings.other_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  },
  methods: {
    /*
     * Call API to get user info
     *
     * @return void
     */
    async getUserInfo () {
      try {
        const response = await SettingService.getSellerInformation()
        if (Object.keys(response).length === 0) {
          this.$emit('checkData', false)
        } else {
          this.$emit('checkData', true)
          this.userInfo = {...response.seller}
          this.defaultUserInfo = {...this.userInfo}
        }
      } catch (err) {
        this.err = err
      } finally {
        if (this.$route.params.tab === 'others') {
          this.$events.fire('done')
        }
      }
    },
    /*
     * Call API to update seller information
     *
     * @return void
     */
    async updateSetting () {
      let self = this
      let logParams = {}
      logParams = {
        name: eventCode.settings.other_tab.click_update_setting_notification_button,
        properties: {
          oldSettingNotificationInfo: {
            noticeEmail: self.defaultUserInfo.noticeEmail,
            isNoticeEmail: self.defaultUserInfo.isNoticeEmail
          },
          newSettingNotificationInfo: {
            noticeEmail: self.userInfo.noticeEmail,
            isNoticeEmail: self.userInfo.isNoticeEmail
          }
        }
      }

      EventService.postTrackLog(logParams)

      let result = await self.$validator.validateAll()
      if (result) {
        self.loader = self.$loading.show()
        const payload = {
          record: {
            noticeEmail: self.userInfo.noticeEmail,
            isNoticeEmail: self.userInfo.isNoticeEmail
          }
        }
        SettingService.updateSetting(payload)
          .then((response) => {
            self.$store.commit('toggleModal', {
              show: true,
              message: Const.updateSuccess
            })
          })
          .catch((err) => {
            self.$store.commit('toggleModal', {
              show: true,
              message: err
            })
            self.userInfo = {...self.defaultUserInfo}
            self.err = err
          })
          .finally(() => {
            this.getUserInfo()
            self.loader && self.loader.hide()
          })
      }
    },
    /*
     * Check disabled submit button
     *
     * @return void
     *
     */
    async checkDisabledButton () {
      let result = await this.$validator.validate(null, null, { silent: true })
      this.disabled = !result
    }
  },
  computed: {
    isNoticeEmail: {
      get: function () {
        if (this.userInfo.isNoticeEmail === null) return false
        return this.userInfo.isNoticeEmail
      },
      set: function (newValue) {
        if (newValue) {
          this.userInfo.isNoticeEmail = true
        } else {
          this.userInfo.isNoticeEmail = false
        }
      }
    }
  },
  watch: {
    userInfo: {
      handler () {
        this.checkDisabledButton()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.discription {
  margin-bottom: 0;
}
.example {
  margin: 18px 0;
}
.example-rate {
  margin-left: 26px;
}
.example-arrow {
  margin: 0 32px;
}
.offer-rate-form {
  width: 80px !important;
  display: inline-flex;
  margin-right: 8px;
}
.noti-setting-discription {
  margin-bottom: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/Others.vue